import {
    Component,
    EventEmitter,
    Output,
    ElementRef,
    Input,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    input,
} from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'fn-table-search',
    templateUrl: 'fn-table.search.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class FnTableSearchComponent implements OnInit {
    public debouncer: Subject<string> = new Subject();
    @Output() search = new EventEmitter<string>();
    @Output() closeSearch = new EventEmitter<string>();
    @Input() config: { actionClear: Subject<boolean> };
    @Input() tblSearchClass = 'right';
    @Input() inputSrchClass = 'fn-global-times red';

    constructor(private el: ElementRef) {
        this.debouncer.pipe(debounceTime(200)).subscribe((val) => {
            this.search.emit(val);
        });
    }

    ngOnInit(): void {
        this.tblSearchClass = this.tblSearchClass || 'right';
        this.inputSrchClass = this.inputSrchClass || 'fn-global-times red';
        this.config.actionClear.subscribe((val) => {
            if (val) {
                this.clear();
            }
            this.el.nativeElement.lastChild.value = '';
        });
    }

    debounce(value: string) {
        this.debouncer.next(value);
    }

    private clear() {
        const ele: any = document.getElementById('fn-table-serch-i');
        if (ele) {
            ele.value = '';
        }
    }

    handleClose(event: any) {
        this.closeSearch.emit('true');
        this.clear();
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}
